import React from 'react';
import { Menu } from 'lucide-react';
import './index.scss';

const Topbar = ({ onMenuClick, sidebarIsOpen }) => {
    return (
        <div className="topbar">
            <div className={`topbar-left ${sidebarIsOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
                <button
                    className="toggle-btn"
                    onClick={onMenuClick}
                    title="Toggle sidebar"
                >
                    <Menu size={20} />
                </button>
            </div>

            <div className="topbar-right">
                <div className="topbar-actions">
                    {/* Add any right-side actions here */}
                </div>
            </div>
        </div>
    );
};

export default Topbar;
